module.exports = __webpack_public_path__ + "static/media/hp_01.0bbca45e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_01.jpg
// module id = 5812
// module chunks = 0